import { useState } from "react";
import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";
import type { IssuedInvitation } from "./types";
export function InvitationLinkDialog({ invitation, onClose }: { invitation: IssuedInvitation | null; onClose: () => void }) {
  const [copyState, setCopyState] = useState("");
  return <Modal styles={{header:{flexDirection:"row-reverse"},title:{flex:1},close:{marginInlineStart:0,marginInlineEnd:12}}} opened={!!invitation} onClose={() => { setCopyState(""); onClose(); }} title="Transmettre l’invitation" closeButtonProps={{ "aria-label": "Fermer l’invitation" }}>
    <Stack>
      <Text>Copiez ce lien et transmettez-le à la personne invitée. Elle choisira son mot de passe.</Text>
      <label>Lien d’invitation<textarea className="accounts-link" readOnly value={invitation?.link || ""} onFocus={event => event.currentTarget.select()} /></label>
      <Text size="sm" c="dimmed">Valable 7 jours, une seule fois. Après fermeture, vous pourrez générer un nouveau lien.</Text>
      {copyState ? <Alert color={copyState === "Lien copié." ? "green" : "yellow"} role="status">{copyState}</Alert> : null}
      <Group justify="flex-end"><Button variant="default" onClick={onClose}>Terminer</Button><Button onClick={async () => {
        try { await navigator.clipboard.writeText(invitation!.link); setCopyState("Lien copié."); }
        catch { setCopyState("La copie automatique est indisponible. Sélectionnez le lien pour le copier manuellement."); }
      }}>Copier le lien</Button></Group>
    </Stack>
  </Modal>;
}
